import Vue from "vue";

import ElementUI from "element-ui";
import Fragment from "vue-fragment";
import VueScrollTo from "vue-scrollto";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "element-ui/lib/theme-chalk/index.css";
import "../public/css/main.css";
import locale from "element-ui/lib/locale/lang/en";
import "../node_modules/nprogress/nprogress.css";
import * as VueGoogleMaps from "vue2-google-maps";
import VueFriendlyIframe from "vue-friendly-iframe";
import Dayjs from "vue-dayjs";
import CKEditor from "ckeditor4-vue";

Vue.use(Dayjs);
Vue.use(VueFriendlyIframe);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAfx9b49Mlb8IaSQU5mfuqGDVVkdF8Dhzw",
    libraries: "places", // necessary for places input
  },
});

Vue.use(ElementUI, { locale });
Vue.use(Fragment.Plugin);
Vue.use(VueScrollTo);
Vue.use(VuePhoneNumberInput);
Vue.use(CKEditor);
